// Conservative email check — we don't want to surface a mailto: link unless
// the value looks like a single, well-formed address. Defense against header
// injection (newlines, ?cc=, ?subject=) coming from API data.
const EMAIL_PATTERN = /^[^\s,;@<>]+@[^\s,;@<>]+\.[^\s,;@<>]+$/;

export function safeMailtoHref(email: string): string | null {
  if (!EMAIL_PATTERN.test(email)) return null;
  return `mailto:${encodeURIComponent(email)}`;
}
